// Themed World Backgrounds for the Mario Party-style World Map
// Each theme has gradients, floating elements, and ambient effects

export const WORLD_BACKGROUNDS = {
    island: {
        id: 'island',
        name: 'Tropical Island',
        gradient: 'linear-gradient(180deg, #87CEEB 0%, #4BA3C7 30%, #1E90FF 60%, #006994 100%)',
        floatingElements: [
            { emoji: '🌴', count: 3 },
            { emoji: '☁️', count: 4 },
            { emoji: '🐚', count: 2 },
            { emoji: '🦀', count: 1 }
        ],
        ambientClass: 'ambient-waves',
        accentColor: '#4BA3C7',
        particleColor: 'rgba(255, 255, 255, 0.6)'
    },
    forest: {
        id: 'forest',
        name: 'Enchanted Forest',
        gradient: 'linear-gradient(180deg, #2d5a2d 0%, #1a4d1a 40%, #0f3d0f 70%, #0a2d0a 100%)',
        floatingElements: [
            { emoji: '🌲', count: 4 },
            { emoji: '🍄', count: 3 },
            { emoji: '🦋', count: 2 },
            { emoji: '🌿', count: 3 }
        ],
        ambientClass: 'ambient-fireflies',
        accentColor: '#4ade80',
        particleColor: 'rgba(144, 238, 144, 0.5)'
    },
    mountain: {
        id: 'mountain',
        name: 'Mountain Peak',
        gradient: 'linear-gradient(180deg, #8B9DC3 0%, #5D6B8A 30%, #4A5568 60%, #2D3748 100%)',
        floatingElements: [
            { emoji: '🏔️', count: 2 },
            { emoji: '🦅', count: 2 },
            { emoji: '❄️', count: 4 },
            { emoji: '⛰️', count: 2 }
        ],
        ambientClass: 'ambient-snow',
        accentColor: '#8B9DC3',
        particleColor: 'rgba(255, 255, 255, 0.8)'
    },
    desert: {
        id: 'desert',
        name: 'Golden Desert',
        gradient: 'linear-gradient(180deg, #F4A460 0%, #DEB887 30%, #CD853F 60%, #8B4513 100%)',
        floatingElements: [
            { emoji: '🌵', count: 3 },
            { emoji: '☀️', count: 1 },
            { emoji: '🐪', count: 1 },
            { emoji: '🏜️', count: 2 }
        ],
        ambientClass: 'ambient-heat',
        accentColor: '#F4A460',
        particleColor: 'rgba(255, 215, 0, 0.4)'
    },
    space: {
        id: 'space',
        name: 'Cosmic Frontier',
        gradient: 'linear-gradient(180deg, #0f0c29 0%, #1a1a3e 30%, #24243e 60%, #191970 100%)',
        floatingElements: [
            { emoji: '🚀', count: 1 },
            { emoji: '🌟', count: 5 },
            { emoji: '🌙', count: 1 },
            { emoji: '🪐', count: 2 }
        ],
        ambientClass: 'ambient-stars',
        accentColor: '#9370DB',
        particleColor: 'rgba(255, 255, 255, 0.9)'
    },
    ocean: {
        id: 'ocean',
        name: 'Deep Ocean',
        gradient: 'linear-gradient(180deg, #006994 0%, #004d7a 30%, #003d5b 60%, #00243a 100%)',
        floatingElements: [
            { emoji: '🐠', count: 3 },
            { emoji: '🐙', count: 1 },
            { emoji: '🌊', count: 2 },
            { emoji: '🐚', count: 2 }
        ],
        ambientClass: 'ambient-bubbles',
        accentColor: '#00CED1',
        particleColor: 'rgba(0, 206, 209, 0.5)'
    },
    volcano: {
        id: 'volcano',
        name: 'Volcanic Realm',
        gradient: 'linear-gradient(180deg, #8B0000 0%, #5c1a1a 30%, #3d0f0f 60%, #1a0505 100%)',
        floatingElements: [
            { emoji: '🌋', count: 1 },
            { emoji: '🔥', count: 3 },
            { emoji: '💎', count: 2 },
            { emoji: '🪨', count: 2 }
        ],
        ambientClass: 'ambient-embers',
        accentColor: '#FF6347',
        particleColor: 'rgba(255, 99, 71, 0.6)'
    },
    crystal: {
        id: 'crystal',
        name: 'Crystal Caves',
        gradient: 'linear-gradient(180deg, #9370DB 0%, #7B68EE 30%, #6A5ACD 60%, #483D8B 100%)',
        floatingElements: [
            { emoji: '💎', count: 4 },
            { emoji: '✨', count: 4 },
            { emoji: '🔮', count: 2 },
            { emoji: '💠', count: 2 }
        ],
        ambientClass: 'ambient-sparkle',
        accentColor: '#E6E6FA',
        particleColor: 'rgba(230, 230, 250, 0.7)'
    }
};

// Get theme by ID
export const getWorldTheme = (themeId) => {
    return WORLD_BACKGROUNDS[themeId] || WORLD_BACKGROUNDS.island;
};

// Generate floating element positions
export const generateFloatingPositions = (theme) => {
    const positions = [];
    let index = 0;

    theme.floatingElements.forEach(element => {
        for (let i = 0; i < element.count; i++) {
            positions.push({
                id: `float-${index}`,
                emoji: element.emoji,
                left: `${10 + Math.random() * 80}%`,
                top: `${10 + Math.random() * 60}%`,
                size: 1.5 + Math.random() * 1.5,
                animationDelay: Math.random() * 5,
                animationDuration: 15 + Math.random() * 10
            });
            index++;
        }
    });

    return positions;
};

export default WORLD_BACKGROUNDS;
